// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogLayout_container__1TFYJ","title":"BlogLayout_title__345vN"};